
export const PAGES_TITLE = {
  "/logged-out": "Logged out - Next Level HR",
  "/not/authorized": "Unauthorized - Next Level HR",
  "/register": "Register - Next Level HR",
  "/authorization": "Authorization - Next Level HR",
  "/unauthorized": "Unauthorized - Next Level HR",
  "/terms-and-conditions":"Terms - Next Level HR"
};

export const ALLOWED_DOMAINS = ["localhost", "dev.nlhr.pwc.com", "qa.nlhr.pwc.com", "stage.nlhr.pwc.com", "uat.nlhr.pwc.com", "nextlevelhr.pwc.com"];
export const ALLOWED_EM_DOMAINS = ["https://dev.supportcentral.pwc.com", "https://test.supportcentral.pwc.com", "https://supportcentral.pwc.com"]
